import api from '@shared/api';
import routes from '@root/routes';
import type { Listing } from '@root/types';
import actions from '../index';
import analyticsActions from './analyticsActions';

const handleErrors = async response => {
  if (response.ok) return response;

  const errors = await response.json();
  throw Error(errors);
};

type ReceiveListingAction = { type: 'RECEIVE_FETCH_LISTING'; payload: Listing };
const receiveListing = (listing: Listing): ReceiveListingAction => ({
  type: 'RECEIVE_FETCH_LISTING',
  payload: listing,
});
type ReceiveListingFavoritedAction = {
  type: 'RECEIVE_FETCH_LISTING_FAVORITED';
  payload: { listingId: string; favorited: boolean };
};
const receieveListingFavorited = (listingId: string, favorited: boolean) => ({
  type: 'RECEIVE_FETCH_LISTING_FAVORITED',
  payload: { listingId, favorited },
});

const listingPageLoad =
  ({ id, isPreview = false }: { id: string; isPreview: boolean | undefined }) =>
  async dispatch => {
    await dispatch(actions.setListingPage(id, isPreview));

    if (isPreview) {
      dispatch(analyticsActions.listingPageLoaded());
      return;
    }

    try {
      await Promise.all([
        api
          .fetch(routes.api.listing(id))
          .then(handleErrors)
          .then(response => response.json())
          .then(async (listing: Listing) => {
            await dispatch(receiveListing(listing));
            dispatch(analyticsActions.listingPageLoaded());
          }),
        api
          .fetch(routes.api.listingFavorited(id))
          .then(handleErrors)
          .then(response => response.json())
          .then(({ favorited }: { favorited: boolean }) =>
            dispatch(receieveListingFavorited(id, favorited)),
          ),
      ]);
    } catch (e) {
      await dispatch(actions.setNotFoundPage());
    }
  };

export default listingPageLoad;
export type Actions = ReceiveListingAction | ReceiveListingFavoritedAction;
